import 'core-js/stable'
import Vue from 'vue'
import 'es6-promise/auto'
import CoreuiVue from '@coreui/vue'
import VueLazyload from 'vue-lazyload'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import router from './router'
import { configRoutes } from './router'
import App from './App'
import { I18nId } from './const'
import _ from './dateFormat'


import LazyImage from "./page-lib/directives/LazyImage";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { farIcons, fasIcons } from './assets/icons/faIcons'
import PhotoSwipe from "photoswipe/dist/photoswipe";
import PhotoSwipeUI from "photoswipe/dist/photoswipe-ui-default";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import createPreviewDirective from "vue-photoswipe-directive";

const previewDirective = createPreviewDirective(
  {
    shareEl: false,
    fullscreenEl: false,
    bgOpacity: 0.9, // 背景透明度
    allowPanToNext: false,
  },
  PhotoSwipe,
  PhotoSwipeUI
)


farIcons.forEach(icon => {
  library.add(icon)
})

fasIcons.forEach(icon => {
  library.add(icon)
})

Vue.use(VueLazyload, {
  lazyComponent: true,
})
Vue.directive("lazy-image", LazyImage)
Vue.directive("preview", previewDirective)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

const i18nValues = Object.keys(I18nId).map(key => {
  return I18nId[key]
})

store.dispatch('setupInitState', i18nValues).then(() => {
  router.addRoutes(configRoutes(store.state.i18nMessage, store.state.loggedInUser))
  new Vue({
    render: h => h(App),
    el: '#app',
    store,
    router,
    icons,
    components: {
      App
    }
  })
})
